// extracted by mini-css-extract-plugin
export default {"navigateActionContainer":"styles_navigateActionContainer__ONxSh","body":"styles_body__dTVHW","documents":"styles_documents__tPEmc"};